<!-- 职位管理 -->
<template>
  <div class="management">
    <!-- 导航 -->
    <!-- <div class="placeholder">
      <div class="nav" :style="showPoup?'z-index:2000':''">
        <img src="@/assets/img/home/user.png" class="backs" @click="tapMine" />
        <div class="nav-center" @click="show=true">
          {{value[0]}}
          <img src="@/assets/img/home/down.png" />
        </div>
      </div>
    </div>-->
    <!-- 筛选弹窗 -->
    <!-- <van-popup v-model="show" position="top">
      <p class="close" @click="close">{{value[1]}}</p>
    </van-popup>-->
    <div class="recom-title">
      <div class="item-left">
        <span :class="check?'selected':''" @click="recommend(1)">全部</span>
        <span :class="!check?'selected':''" @click="recommend(2)">已关闭</span>
      </div>
      <!-- <router-link to="/home/screen">
        <div class="item-right">
          <span>筛选</span>
          <img src="@/assets/img/home/selectDown.png" />
        </div>
      </router-link>-->
    </div>
    <!-- 列表 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
      >
        <div class="list-box">
          <div
            class="list-item"
            v-for="(item, index) in list"
            :key="index"
            @click="goDetails(item.job_id)"
          >
            <div class="item-position">
              <div class="item-top">
                <span>{{item.job_name}}</span>
                <span>{{item.max_salary==0?'面议':item.min_salary==item.max_salary?item.max_salary:`${item.min_salary}-${item.max_salary}`}}</span>
              </div>
              <div class="item-bottom">
                <span>{{item.district_name}}</span>
                <span>{{item.education==0?'不限':item.education}}</span>
                <span>{{item.experience==0?'不限':item.experience}}</span>
              </div>
            </div>
            <img src="@/assets/img/position/into.png" class="back" />
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- 个人中心 -->
    <!-- 个人中心弹窗 -->
    <!-- <Mine :showPoup="showPoup" @sendMsg="getVlaue" /> -->
    <!-- 按钮 -->
    <div class="placeholders">
      <div class="request-btn" @click="release" style="bottom:1.4rem">
        <button class="btns">发布职位</button>
      </div>
    </div>
  </div>
</template>
<script>
import { companyPositionList } from "@/api/apiData";
import Mine from "../homeBoss/mine";
import { Toast } from "vant";
import { mapMutations } from "vuex";
export default {
  components: { Mine },
  data() {
    return {
      check: true,
      // show: false,
      // value: ["全部", "已关闭"],
      // showPoup: false, //个人中心弹窗
      page: 0,
      totalPages: 1,
      offset: 10,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      open_status: ""
    };
  },
  computed: {},
  methods: {
    ...mapMutations(["keepAliveRouter"]),
    //   个人中心
    // tapMine() {
    //   this.showPoup = true;
    // },
    //获取子组件的传值
    // getVlaue(val) {
    //   this.showPoup = val;
    // },
    //   筛选
    // close(e) {
    //   var that = this;
    //   if (e.target.innerText == "已关闭") {
    //     that.value[0] = e.target.innerText;
    //     that.value[1] = "全部";
    //     that.open_status = 0;
    //   } else {
    //     that.value[0] = e.target.innerText;
    //     that.value[1] = "已关闭";
    //     that.open_status = "";
    //   }
    //   that.show = false;
    //   that.page = 0;
    //   that.totalPages = 1;
    //   that.offset = 10;
    //   that.list = [];
    //   that.loading = false;
    //   that.finished = false;
    //   that.getList();
    // },
    // 推荐
    recommend(val) {
      const that = this;
      that.check = !that.check;
      if (val == 1) {
        //全部
        that.open_status = "";
      } else {
        that.open_status =0;
      }

      that.page = 0;
      that.totalPages = 1;
      that.offset = 10;
      that.list = [];
      that.loading = false;
      that.finished = false;
      that.getList();
    },
    // 发布职位
    release() {
      var that = this;
      that.keepAliveRouter("index");
      that.$router.push({
        name: "EditPosition"
      });
    },
    //上拉加载
    onLoad() {
      this.getList();
    },
    // 前往详情页
    goDetails(id) {
      var that = this;
      that.$router.push({
        path: "/position/positionDetails",
        query: {
          type: 0,
          id: id
        }
      });
    },
    // 下拉刷新
    onRefresh() {
      const that = this;
      that.page = 0;
      that.totalPages = 1;
      that.offset = 10;
      that.list = [];
      that.loading = false;
      that.finished = false;
      that.getList();
      setTimeout(() => {
        that.refreshing = false;
      }, 1500);
    },
    // 获取已发布的职位列表
    getList() {
      var that = this;
      let { page, totalPages, offset, list, open_status } = that;
      let obj = {
        page: page + 1,
        offset: offset,
        open_status: open_status
      };
      if (totalPages > page) {
        companyPositionList(obj).then(res => {
          if (res.code == 1) {
            if (res.data.list.length > 0) {
              that.list = list.concat(res.data.list);
              that.page = page + 1;
              that.totalPages = Math.ceil(Number(res.data.total) / offset);
              setTimeout(() => {
                that.loading = false;
              }, 1500);
            }
            if (res.data.list.length == 0) {
              that.loading = false;
              that.finished = true;
            }
          } else {
            Toast(res.msg);
          }
        });
      } else {
        that.loading = false;
        that.finished = true;
      }
    }
  },
  created() {},
  mounted() {
    this.getList();
  },
  deactivated() {
    //清除keep-alive的缓存
    this.$destroy(true);
  }
};
</script>
<style lang='less' scoped>
/deep/.van-overlay {
  z-index: 2000 !important;
}
.van-popup {
  top: 0;
  z-index: 2001 !important;
  p {
    padding: 1rem 0 0.2rem;
  }
}
.placeholder::after {
  content: "";
  width: 100%;
  height: 0.8rem;
  display: block;
}
.nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2003;
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0.32rem;
  .backs {
    position: absolute;
    left: 0.32rem;
  }
  img {
    width: 0.4rem;
    height: 0.4rem;
  }
  .nav-center {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.32rem;
    font-weight: bold;
    line-height: 0.45rem;
    color: rgba(51, 51, 51, 1);
  }
}
.recom-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.24rem 0.4rem;
  border-bottom: 1px solid rgba(178, 178, 178, 0.3);
  background: #fff;
  .item-left {
    font-size: 0.3rem;
    font-weight: 550;
    line-height: 0.42rem;
    color: rgba(128, 128, 128, 1);

    span {
      margin-right: 0.4rem;
    }
    .selected {
      font-weight: bold;
      color: #ff4343;
    }
  }
  .item-right {
    display: flex;
    align-items: center;
    font-size: 0.24rem;
    font-weight: 500;
    line-height: 0.33rem;
    color: rgba(128, 128, 128, 1);
    background: #f7f7f7;
    padding: 0.1rem 0.15rem;
    border-radius: 0.08rem;
    img {
      width: 0.3rem;
      height: 0.3rem;
    }
  }
}
.close {
  text-align: center;
  font-size: 0.32rem;
  font-weight: bold;
  line-height: 0.45rem;
  color: rgba(51, 51, 51, 1);
  text-indent: -0.3rem;
  padding-top: 0.2rem;
  top: 0.8rem;
}
.list-box {
  padding: 0 0.4rem;
  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.32rem 0;
    border-bottom: 1px solid rgba(178, 178, 178, 0.2);
    .item-position {
      width: 90%;
      font-size: 0.28rem;
      display: flex;
      flex-direction: column;
      .item-top {
        font-size: 0.32rem;
        font-weight: bold;
        line-height: 0.45rem;
        color: rgba(51, 51, 51, 1);
        span {
          margin-right: 0.2rem;
        }
        span:last-child {
          font-size: 0.28rem;
        }
      }
      .item-bottom {
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(102, 102, 102, 1);
        margin-top: 0.2rem;
        span {
          margin-right: 0.2rem;
        }
      }
    }
  }
}
.placeholders::after {
  display: block;
  content: "";
  width: 100%;
  height: 1.5rem;
}
</style>